module.exports = __webpack_public_path__ + "img/supplier.39915384.svg";